"use strict";
exports.__esModule = true;
let index_1 = require("./index");
let flexCode = {
    start: "flex-start",
    end: "flex-end",
    between: "space-between",
    around: "space-around"
};
exports.commonSheets = {
    dis: function (v) { return "{ display: " + v + "; }"; },
    items: function (v) { return "{ align-items: " + (flexCode[v] || v) + ";}"; },
    justify: function (v) { return "{ justify-content: " + (flexCode[v] || v) + "; }"; },
    self: function (v) { return "{ align-self: " + (flexCode[v] || v) + " };"; },
    // content: function (v) { return "{ align-content: " + (flexCode[v] || v) + "; }"; },
    z: function (v) { return "{ z-index: " + v + "; }"; },
    // positions
    p: function (v) { return "{ padding: " + v + "; }"; },
    px: function (v) { return "{ padding-left: " + v + "; padding-right: " + v + ";}"; },
    py: function (v) { return "{ padding-top: " + v + "; padding-bottom: " + v + "; }"; },
    pl: function (v) { return "{ padding-left: " + v + "; }"; },
    pt: function (v) { return "{ padding-top: " + v + "; }"; },
    pr: function (v) { return "{ padding-right: " + v + "; }"; },
    pb: function (v) { return "{ padding-bottom: " + v + "; }"; },
    m: function (v) { return "{ margin: " + v + "; }"; },
    mx: function (v) { return "{ margin-left: " + v + "; margin-right: " + v + "; }"; },
    my: function (v) { return "{ margin-top: " + v + "; margin-bottom: " + v + "; }"; },
    ml: function (v) { return "{ margin-left: " + v + "; }"; },
    mt: function (v) { return "{ margin-top: " + v + " };"; },
    mr: function (v) { return "{ margin-right: " + v + "; }"; },
    mb: function (v) { return "{ margin-bottom: " + v + "; }"; },
    w: function (v) { return "{ width: " + v + " }"; },
    "w-min": function (v) { return "{ min-width: " + v + "; }"; },
    "w-max": function (v) { return "{ max-width: " + v + "; }"; },
    "w-min-max": function (v) { return "{ width: " + v + "; max-width: " + v + "; min-width: " + v + "; }"; },
    h: function (v) { return "{ height: " + v + "; }"; },
    "h-min": function (v) { return "{ min-height: " + v + "; }"; },
    "h-max": function (v) { return "{ maxHeight: " + v + "; }"; },
    "h-min-max": function (v) {
        return "{ height: " + v + "; min-height: " + v + "; max-width: " + v + "; }";
    },
    b: function (v) { return "{ border: " + v + " solid; }"; },
    bl: function (v) { return "{ border-left: " + v + " solid;}"; },
    bt: function (v) { return "{ border-top: " + v + " solid; }"; },
    br: function (v) { return "{ border-right: " + v + " solid;}"; },
    bb: function (v) { return "{ border-bottom: " + v + " solid;}"; },
    bc: function (v) { return "{ border-color: " + v + "; }"; },
    radius: function (v) { return "{ border-radius: " + v + "; }"; },
    font: function (v) { return "{ font-size: " + v + "; }"; },
    // theme
    bg: function (v) { return "{ background: " + v + "; }"; },
    bgc: function (v) { return "{ background-color: " + v + "; }"; },
    // anime
    linear: function (v) { return "{ transition: all " + v + " linear; }"; },
    ease: function (v) { return "{ transition: all " + v + " ease; }"; },
    "ease-in": function (v) { return "{ transition: all " + v + " ease-in; }"; },
    "ease-out": function (v) { return "{ transition: all " + v + " ease-out; }"; },
    "ease-in-out": function (v) { return "{ transition: all " + v + " ease-in-out; }"; },
    "move-x": function (v) { return "{ transform: translateX(" + v + "); }"; },
    "move-y": function (v) { return "{ transform: translateY(" + v + "); }"; },
    "move-z": function (v) { return "{ transform: translateZ(" + v + "); }"; },
    rotate: function (v) { return "{ transform: rotate(" + v + "deg); }"; },
    scale: function (v) { return "{ transform: scale(" + v + ", " + v + "); }"; },
    center: "display:flex; flex-direction:column; justify-content:center; align-items:center;",
    full: "width:100%; height:100%;",
    row: "display:flex; flex-direction:row;",
    "row-reverse": "display:flex; flex-direction:row-reverse;",
    col: "display:flex; flex-direction:column;",
    "col-reverse": "display:flex; flex-direction:column-reverse;",
    fixed: "position:fixed;",
    static: "position:static;",
    absolute: "position:absolute;",
    relative: "position:relative;",
    sticky: "position:sticky;",
    hidden: "display:none;",
    left: "left:0px;",
    top: "top:0px;",
    right: "right:0px;",
    bottom: "bottom:0px;",
    bold: "font-weight: bold",
    ellipsis: 'white-space: nowrap;overflow: hidden;text-overflow: ellipsis;'
};
index_1.addShit(exports.commonSheets);
